import React from 'react';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

/**
 * @function PrimaryButton
 * @param {function} onClick
 * @param {string} className
 * @param {string} text
 * @param {boolean} working
 * @param {boolean} disabled
 * @param {string} [type]
 * @return {JSX.Element}
 * @constructor
 */
const MapButton = ({ onClick, className, text, working, disabled, type }) => {
    return (
        <button className={"border border-black shadow-sm  inline-flex items-left p-2 text-sm font-bold select-none bg-white text-black text-left w-[15em] rounded-md"}>
            <div className={"flex flex-row w-full"}>
                <div className={"w-2/3 bmw-condenced-bold"}>
                    Visit Map
                </div>
                <div className={"w-1/3 text-right font-bold"}>
                    <FontAwesomeIcon icon={faChevronRight}/>
                </div>
            </div>
        </button>
    );
};

export default MapButton;
